import useFavourite from '@discover-data/stores/hooks/favourite/useFavourite';
import Toggle, { ToggleProps } from '@discover-ui/toggle';
import { useAuthState } from '@/components/context/AuthContext';

export type FavouriteOnlyToggleProps = Omit<
  ToggleProps,
  'pressed' | 'onPressedChange' | 'aria-label' | 'children'
>;

export default function FavouriteOnlyToggle({ className, ...props }: FavouriteOnlyToggleProps) {
  const { user } = useAuthState();
  const [favourite, setFavourite] = useFavourite(user?.favouriteIds);

  return (
    <Toggle
      pressed={favourite !== false}
      onPressedChange={setFavourite}
      aria-label="Favourites"
      className={className}
      {...props}>
      Favourites
    </Toggle>
  );
}
